exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body span[data-v-5df88ab2]{vertical-align:inherit}.member-card[data-v-5df88ab2]{min-width:350px}.member-avatar[data-v-5df88ab2]{text-align:left;-ms-flex-negative:0;flex-shrink:0;margin-right:0;margin-top:20px;width:100px;float:left}.member-avatar>img[data-v-5df88ab2]{border-radius:100%;width:85%;height:85%}.member-info[data-v-5df88ab2]{margin-top:.5rem;font-family:Open Sans,Helvetica Neue,Helvetica,Arial,Sans-Serif;float:left}.member-info .boldish[data-v-5df88ab2],.member-info .name[data-v-5df88ab2]{font-weight:550}.member-info .title[data-v-5df88ab2]{max-width:180px}.member-info .email[data-v-5df88ab2]{max-width:10px}", ""]);

// exports
